import { useLocation } from 'react-router-dom';
import { parse } from 'hub-http/helpers/params';
export const useQueryParams = () => {
  const {
    search
  } = useLocation();
  return parse(search.substring(1));
};
export default useQueryParams;